import { OnInit } from '@angular/core';
var ClientSelectComponent = /** @class */ (function () {
    function ClientSelectComponent() {
    }
    ClientSelectComponent.prototype.ngOnInit = function () {
    };
    return ClientSelectComponent;
}());
export { ClientSelectComponent };
